<template>
  <v-form  ref="form" v-model="valid" lazy-validation>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-text>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-select label="Typ vouchera" :items="typy_voucherow" v-model="typ" :rules="[typ_rules.required]"></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" v-if="typ != null && typ >= 0">
                    <v-text-field label="Ilość wizyt" v-if="typ === 0" v-model.number="ilosc_wizyt" :rules="[ilosc_wizyt_rules.numbers, ilosc_wizyt_rules.min]"
                                  type="number"></v-text-field>
                    <v-text-field label="Czas (minuty)" v-if="typ === 1" v-model.number="czas_minuty" :rules="[czas_minuty_rules.numbers, czas_minuty_rules.min]"
                                  type="number"></v-text-field>
                    <v-text-field label="Kwota do wykorzystania (zł)" v-if="typ === 2" v-model.number="kwota_do_wykorzystania" :rules="[kwota_do_wykorzystania_rules.numbers, kwota_do_wykorzystania_rules.min]"
                                  type="number" @input="handleInput2"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12"  sm="12" lg="6" md="6">
                    <v-text-field v-model="nazwa" label="Nazwa vouchera"  :rules="[nazwa_rules.required, nazwa_rules.min_length]"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field label="Cena (zł)" v-model.number="cena" :rules="[cena_rules.numbers, cena_rules.min]"
                                  type="number" @input="handleInput"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" lg="6" md="6">
                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="data_waznosci_system"
                            label="Data ważności w systemie"
                            placeholder="Nie podana - bez limitu"
                            prepend-icon="fa-calendar-alt"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="data_waznosci_system"
                          @input="menu2 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="12" lg="6" md="6">
                    <v-text-field label="Ważność dla klienta (miesiące)" v-model.number="waznosc_miesiace" placeholder="Wartość 0 - bez limitu ważności" :rules="[waznosc_miesiace_rules.numbers, waznosc_miesiace_rules.min]"
                                  type="number" @input="handleInput"></v-text-field>
                  </v-col>
                </v-row>

              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="save">Zapisz</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import {voucheryService} from "@/services/vouchery.service";
import swal from "sweetalert";

export default {
  name: "DodawanieVouchera",
  data() {
    return {
      nazwa: null,
      valid: true,
      cena: 0,
      data_waznosci_system: null,
      previousPrice: 0,
      waznosc_miesiace: null,
      ilosc_wizyt: 0,
      czas_minuty: 0,
      kwota_do_wykorzystania: 0,
      previous_kwota: 0,
      menu2: false,
      typ: null,
      numer: null,
      typy_voucherow : [
        { value: 0, text: 'Wizyta'},
        { value: 1, text: 'Czas'},
        { value: 2, text: 'Kwota'}
      ],
      ilosc_wizyt_rules: {
        numbers: value => !isNaN(value) || 'Ilośc wizyt musi być liczbą',
        min: value => Number(value) > 0 || 'Ilośc wizyt musi być wieksza od 0'
      },
      czas_minuty_rules: {
        numbers: value => !isNaN(value) || 'Ilośc minut musi być liczbą',
        min: value => Number(value) > 0 || 'Ilośc minut musi być wieksza od 0'
      },
      kwota_do_wykorzystania_rules: {
        numbers: value => !isNaN(value) || 'Kwota do wykorzystania musi być liczbą',
        min: value => Number(value) > 0 || 'Kwota do wykorzystania musi być wieksza od 0'
      },
      typ_rules: {
        required: value => !(value == null || value < 0) || 'Typ wizyty jest wymagany'
      },
      nazwa_rules: {
        required: value => !!value || 'Nazwa jest wymagana',
        min_length: value => !(value && value.length < 3) || 'Nazwa musi posiadać minimum 3 znaki'
      },
      cena_rules: {
        numbers: value => !isNaN(value) || 'Cena musi być liczbą',
        min: value => Number(value) > 0 || 'Cena nie może być mniejsza od 0'
      },
      waznosc_miesiace_rules: {
        numbers: value => !isNaN(value) || 'Ważność musi być wyrażona liczbą całkowita',
        min: value => Number(value) >= 0 || 'Ważność musi być większa lub równa 0'
      },
    }
  },
  methods: {
    handleInput(e) {
      let stringValue = e
      let regex = /^\d*(\,\d{1,2})?$/
      if (!stringValue.match(regex) && this.cena !== '') {
        this.cena = this.previousPrice
      }
      this.previousPrice = this.cena
    },
    handleInput2(e) {
      let stringValue = e
      let regex = /^\d*(\,\d{1,2})?$/
      if (!stringValue.match(regex) && this.kwota_do_wykorzystania !== '') {
        this.kwota_do_wykorzystania = this.previous_kwota
      }
      this.previous_kwota = this.kwota_do_wykorzystania
    },
    save() {
      if (this.$refs.form.validate()) {
        voucheryService.create({
          nazwa: this.nazwa,
          typ: this.typ,
          waznosc_miesiace: this.waznosc_miesiace ? this.waznosc_miesiace : 0,
          data_waznosci_system: this.data_waznosci_system,
          aktywny: true,
          ilosc_wizyt: this.ilosc_wizyt ? this.ilosc_wizyt : 0,
          czas_minuty: this.czas_minuty ? this.czas_minuty : 0,
          kwota_do_wykorzystania: this.kwota_do_wykorzystania ? this.kwota_do_wykorzystania : 0,
          kwota: this.cena
        }).then((result) => {
          //redirect to list
          swal({
            title: 'Dodano',
            text: 'Pomyślnie dodano voucher',
            icon: 'success',
            button: "Zamknij"
          }).then(() => {
            this.$emit('added',result.data.result)
          })
        }).catch(err => {

          if(err.response != null && err.response.data != null && err.response.data.error != null)
          {
            this.showError(err.response.data.error.message)
          }
          else
          {
            this.showError('Błąd zapisu vouchera')
          }
        })
      }
    },
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
      });
    }
  }
}
</script>

<style scoped>

</style>